import React from "react";

import { Router, Switch, Route, Redirect } from "react-router-dom";

import BrowserHistoryHelper from "./util/BrowserHistoryHelper";
import TableViewComponent from "./presentation/view/dashboard/TableViewComponent";
import LoginComponent from "./presentation/view/auth/LoginComponent";
import ForgotPasswordComponent from "./presentation/view/auth/ForgotPasswordComponent";
import AuthRepository from "./domain/repositories/auth/AuthRepository";
import AuthRepositoryImpl from "./data/repositories/auth/AuthRepositoryImpl";
import AuthViewModel from "./presentation/view-model/auth/AuthViewModel";
import AuthViewModelImpl from "./presentation/view-model/auth/AuthViewModelImpl";
import AdminComponent from "./presentation/view/admin/AdminComponent";
import AdminRepository from "./domain/repositories/admin/AdminRepository";
import AdminRepositoryImpl from "./data/repositories/admin/AdminRepositoryImpl";
import NavbarViewModelImpl from "./presentation/view-model/navbar/NavbarViewModelImpl";
import AdminViewModel from "./presentation/view-model/admin/AdminViewModel";
import AdminViewModelImpl from "./presentation/view-model/admin/AdminViewModelImpl";
import NavbarViewModel from "./presentation/view-model/navbar/NavbarViewModel";
import CountryHolder from "./domain/models/country/CountryHolder";
import TableViewModel from "./presentation/view-model/dashboard/TableViewModel";
import TableViewModelImpl from "./presentation/view-model/dashboard/TableViewModelImpl";
import DashboardRepository from "./domain/repositories/dashboard/DashboardRepository";
import DashboardRepositoryImpl from "./data/repositories/dashboard/DashboardRepositoryImpl";
import VersionComponent from "./presentation/view/version/VersionComponent";

const App = (): JSX.Element => {
  // repositories
  const authRepository: AuthRepository = new AuthRepositoryImpl();
  const adminRepository: AdminRepository = new AdminRepositoryImpl(authRepository);
  const dashboardRepository: DashboardRepository = new DashboardRepositoryImpl(authRepository);

  // domain
  const countryHolder: CountryHolder = new CountryHolder();

  // view models
  const authViewModel: AuthViewModel = new AuthViewModelImpl(authRepository);
  const adminViewModel: AdminViewModel = new AdminViewModelImpl(adminRepository);
  const tableViewModel: TableViewModel = new TableViewModelImpl(dashboardRepository, countryHolder);

  return (
    <div className="App" id="app-root">
      <Router history={BrowserHistoryHelper.getHistory()}>
        <Switch>
          <Route exact path="/version">
            <VersionComponent />
          </Route>
          <Route exact path="/login">
            <LoginComponent authViewModel={authViewModel} />
          </Route>

          <Route exact path="/forgot-password">
            <ForgotPasswordComponent authViewModel={authViewModel} />
          </Route>

          <Route exact path="/admin">
            <AdminComponent
              navbarViewModel={new NavbarViewModelImpl(authRepository, countryHolder)}
              adminViewModel={adminViewModel}
            />
          </Route>

          <Route exact path="/main">
            <TableViewComponent
              tableViewModel={tableViewModel}
              navbarViewModel={new NavbarViewModelImpl(authRepository, countryHolder)}
            />
          </Route>

          <Route>
            <Redirect to="/main" />
          </Route>
        </Switch>
      </Router>
    </div>
  );
};

export default App;
